import { Skeleton, Stack } from "@mui/material";

function Loading2() {
    return (
        <Stack spacing={1}>
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            <Skeleton variant="rounded" height={60} />
            <Skeleton variant="rounded" height={120} />
            <Skeleton variant="rounded" height={60} />
            <Skeleton variant="rounded" height={80} />
            <Skeleton variant="rounded" height={40} />
            <Skeleton variant="rounded" height={120} />
            <Skeleton variant="rounded" height={60} />
        </Stack>
    );
}

export default Loading2;
